import { render, staticRenderFns } from "./FormValidator.vue?vue&type=template&id=fb71ef3a&"
import script from "./FormValidator.vue?vue&type=script&lang=js&"
export * from "./FormValidator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports